import { Controller } from "@hotwired/stimulus"
import { reapplyAlternatingRows } from "../js/alternating_rows"

export default class extends Controller {
  connect() {
    this.filterHandler = (e) => this.filterResults(e)
    this.scrollHandler = (e) => this.scroll(e)

    this.element.querySelectorAll(".header-filter").forEach((item) => {
      item.addEventListener("click", this.filterHandler)
    })

    this.element.querySelectorAll(".scroller").forEach((item) => {
      item.addEventListener("click", this.scrollHandler)
    })
  }

  disconnect() {
    this.element.querySelectorAll(".header-filter").forEach((item) => {
      item.removeEventListener("click", this.filterHandler)
    })

    this.element.querySelectorAll(".scroller").forEach((item) => {
      item.removeEventListener("click", this.scrollHandler)
    })
  }

  filterResults(e) {
    e.preventDefault()
    const targetClass = e.currentTarget.dataset.target
    const allRows = document.querySelectorAll(".header-result")

    if (targetClass === "all") {
      allRows.forEach(el => el.classList.remove("d-none"))
    } else if (targetClass === "options") {
      allRows.forEach(el => el.classList.remove("d-none"))
      document.querySelectorAll(".header-mechanical, .header-exterior, .header-interior, .header-safety")
        .forEach(el => el.classList.add("d-none"))
    } else {
      allRows.forEach(el => el.classList.add("d-none"))
      document.querySelectorAll(`.header-${targetClass}`)
        .forEach(el => el.classList.remove("d-none"))
    }

    this.reapplyAlternatingRows()
  }

  scroll(e) {
    const element = document.getElementById(e.target.dataset.targetId)
    if (!element) return
    element.scrollIntoView({
      behavior: "smooth",
      block: "start",
      inline: "nearest",
    })
  }

  reapplyAlternatingRows() {
    reapplyAlternatingRows()
  }
}
